import React from "react";
import "./Button.scss";
import { Loader } from "../../assets/images/index";
import { useLayoutContext } from "../../layouts/general-layout";

interface ButtonProps {
  text?: string;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  iconOnly?: boolean;
  color?: "blue" | "green" | "red" | "black" | "orange" | "green-small" | "lightBlue" | "transparent" | "purple";
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  loader?: boolean;
  outline?: boolean;
  size?: "sm" | "md" | "lg";
}

export default function Button({
  text,
  icon,
  iconRight,
  iconOnly = false,
  color = "blue",
  onClick,
  className = "",
  style,
  type = "button",
  disabled = false,
  loading = false,
  loader = false,
  outline = false,
  size = "md",
}: ButtonProps) {
  const { t } = useLayoutContext();
  const variantClass = `button--${outline ? `outline-${color}` : color}`;
  const contentClass = iconOnly ? "button--icon-only" : "";
  const sizeClass = `button--${size}`;

  return (
    <button
      type={type}
      className={`button ${variantClass} ${sizeClass} ${contentClass} ${className} ${loading ? "button--loading" : ""}`}
      onClick={onClick}
      style={style}
      disabled={disabled || loading}
    >
      {loading ? (
        t('generating')
      ) : (
        <>
          {icon && <span className="button-icon-left">{icon}</span>}
          {!iconOnly && <span>{text}</span>}
          {iconRight && <span className="button-icon-right">{iconRight}</span>}
        </>
      )}
      {loader && (
        <div className="loaderBlock">
          <img src={Loader} alt="Loader" />
        </div>
      )}
    </button>
  );
}
